import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { closeModal } from '../../redux/actions/modals';
import { updateAdjustment } from '../../redux/actions/plan';
import ReactLoading from 'react-loading';

const mapStateToProps = ({ movePlan, auth, inventory, plan }) => ({
	isSuperAdmin: auth.isSuperAdmin,
	inventoryRooms: inventory.inventoryItems,
	priceRate: movePlan.currentPlan.price_per_cubic_foot_per_flight_of_stairs,
	mpid: movePlan.currentMPID,
	loading: plan.adjustmentLoading,
});
const PartialStairCarryModal = props => {
	const [item, setItem] = useState();
	const [stairs, setStairs] = useState(1);
	const [qty, setQty] = useState(1);
	const [tableText, setTableText] = useState();
	const [tableAmount, setTableAmount] = useState();
	let itemList = [];
	const { inventoryRooms, priceRate, mpid, updateAdjustment } = props;
	useEffect(() => {
		if (!!inventoryRooms && Object.keys(inventoryRooms).length > 0) {
			Object.keys(inventoryRooms).forEach(roomKey => {
				Object.keys(inventoryRooms[roomKey]).forEach(itemKey => {
					itemList.push({
						value: inventoryRooms[roomKey][itemKey].id,
						label: inventoryRooms[roomKey][itemKey].name,
						desc: inventoryRooms[roomKey][itemKey].description,
						cubic_feet: inventoryRooms[roomKey][itemKey].cubic_feet,
					});
				});
			});
		}
	}, [inventoryRooms, itemList]);
	useEffect(() => {
		const calculatePrice = () => {
			if (!!!item) return;
			setTableText(
				`(${qty}) ${item.label} - ${stairs} ${
					stairs > 1 ? 'Flights' : 'Flight'
				} of Stairs`
			);
			setTableAmount(item.cubic_feet * priceRate * stairs * qty);
		};
		calculatePrice();
	}, [item, stairs, qty, priceRate]);

	const submit = () => {
		if (tableAmount <= 0) return;
		updateAdjustment({
			amount_in_dollars: tableAmount,
			applies_to: 'both',
			description: tableText,
			is_applied_before_discounts: true,
			is_percentage: false,
			move_plan_id: mpid,
			percentage: null,
		});
	};
	return (
		<div>
			<header className="top-action-panel">
				<span className="close-reveal-modal" onClick={() => props.closeModal()}>
					✖
				</span>
			</header>
			<div className="modal-body pt-0">
				<h3 className="title">Partial Stair Carry</h3>
				<div className="container p-0">
					{!props.isSuperAdmin && (
						<p className="col-12 field-error-message message">
							Must be a super admin to submit a partial stair carry adjustment.
						</p>
					)}
					<br />
					<div className="row">
						<div className="col-12 col-md-5 item-select-column">
							<p>Select item from move plan</p>
							<Select
								isSearchable
								className="control time-select mb-3"
								options={itemList}
								styles={customStyles}
								getOptionLabel={option => {
									return !!option.desc
										? option.label + ' - ' + option.desc
										: option.label;
								}}
								placeholder="Click here to start typing..."
								onChange={selectedOption => {
									setItem(selectedOption);
								}}
							/>
						</div>
						<div className="col-12 col-md-3 ">
							<p>Flights of stairs</p>
							<Counter
								cssClass={'orange left'}
								handleChange={setStairs}
								count={stairs}
							/>
						</div>

						<div className="col-12 col-md-3 offset-0 offset-md-1">
							<p>Item quantity</p>
							<Counter
								cssClass={'orange left'}
								handleChange={setQty}
								count={qty}
							/>
						</div>
					</div>

					<br />
					<div className="table-scroll">
						{!!item && (
							<table className="flat-table">
								<thead>
									<tr className="table-titles">
										<th className="table-title">Description</th>
										<th className="table-title">Amount</th>
									</tr>
								</thead>
								<tbody className="table-items">
									<tr className="table-item">
										<td className="adjustment">{tableText}</td>
										<td className="adjustment">
											{new Intl.NumberFormat('en-US', {
												style: 'currency',
												currency: 'USD',
											}).format(tableAmount)}
										</td>
									</tr>
								</tbody>
							</table>
						)}
					</div>
				</div>
			</div>
			<footer className="bottom-action-panel ">
				<button
					aria-label="Cancel"
					className="btn-small secondary"
					onClick={() => props.closeModal()}>
					Cancel
				</button>
				<button
					aria-label="Add adjustment"
					className="btn-small primary"
					disabled={props.loading}
					onClick={submit}>
					{props.loading ? (
						<ReactLoading
							className="m-auto"
							type={'spokes'}
							color={'#ddd'}
							height={22}
							width={22}
						/>
					) : (
						'Add Adjustment'
					)}
				</button>
			</footer>
			<style jsx>{`
				.title {
					font-family: 'UnpaktHelvetica', sans-serif;
					font-size: 22px;
					display: block;
					margin-bottom: 6px;
					text-transform: uppercase;
				}
				td {
					border-width: 0 1px 1px 0;
					border-style: solid;
					border-color: #dbdbdb;
					padding: 1em;
					min-width: 165px;
				}
				.btn-small {
					min-width: 150px;
				}
				.close-reveal-modal {
					width: 40px;
					font-size: 26px;
					line-height: 50px;
					color: #042b3b;
					text-align: center;
				}
				.table-scroll {
					overflow-x: scroll;
					overflow-y: hidden;
				}
			`}</style>
		</div>
	);
};

const customStyles = {
	option: (initial, state) => ({
		...initial,
		color: state.isDisabled ? '#ebebeb' : '#042B3B',
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		zIndex: 10,
		border: '1px solid #829ca1',
		borderTop: 0,
		height: '50px',
		backgroundColor: state.isFocused || state.isSelected ? '#e2e3e5;' : 'white',
		borderLeft:
			state.isFocused || state.isSelected ? '3px solid #F78022' : 'auto',
		paddingLeft: state.isFocused || state.isSelected ? 10 : 'auto',
	}),
	container: (initial, state) => ({
		...initial,
		border:
			state.isFocused || state.isSelected
				? '1px solid #022b3c'
				: '1px solid #829ca1',
		minWidth: '250px',
		height: '40px',
		fontSize: 13,
		borderRadius: '1px',
		cursor: 'pointer',
	}),
	control: () => ({
		display: 'flex',
		color: '#f7801e',
		padding: '5px 5px',
	}),
	dropdownIndicator: () => ({}),
	menu: () => ({
		height: 0,
	}),
};

const Counter = props => {
	let { count, handleChange } = props;
	const handleInputChange = e => {
		if (e.target.value < 100 && e.target.value > 0)
			handleChange(parseInt(e.target.value));
	};
	const remove = () => {
		if (count > 1) handleChange(count - 1);
	};
	return (
		<div className="plus-minus-holder">
			<input
				value={count}
				onChange={handleInputChange}
				className="count-input"
			/>
			<div className={`btns-counter ${props.cssClass}`}>
				<span className="minus left" onClick={remove}>
					-
				</span>
				<span className="separator" />
				<span className="plus right" onClick={() => handleChange(count + 1)}>
					+
				</span>
			</div>
			<style jsx>
				{`
					.btns-counter {
						display: flex;
						color: orange;
						font-size: 16px;
						position: relative;
						border: 1px solid #dddddd;
						border-radius: 3px;
						font-family: 'UnpaktHelvetica', sans-serif;
						line-height: 100%;
						min-width: 40px;
						min-height: 15px;
						width: 110px;
						height: inherit;
						line-height: 30px;
						padding: 0;
						border-radius: 2px;
						width: 100%;
					}
					.btns-counter:hover {
						border: 1px solid #f7801e;
					}

					.separator {
						position: absolute;
						width: 1px;
						height: 70%;
						top: 15%;
						left: 50%;
						margin: auto -0.5px;
						background-color: #dddddd;
					}

					.plus,
					.minus {
						line-height: 37px;
						width: 50%;
						height: 100%;
						text-align: center;
						cursor: pointer;
					}
					.count-container {
						width: 30%;
						padding-right: 1rem;
					}
					.count-input {
						font-size: 24px;
						font-weight: 800;
						max-width: calc(100% - 1px);
						margin-left: 0.15rem;
						margin-right: 1rem;
						padding-right: 0.4rem;
						height: inherit;
						border: none;
						max-width: 24%;
						font-family: 'UnpaktHelveticaBold', sans-serif;
						font-size: 1.5em;
						line-height: 30px;
						text-align: end;
						overflow: visible;
						justify-self: flex-end;
						border-width: 1px 1px 1px 1px;
						border-style: solid;
						border-color: #dddddd;
					}
					.count-input:hover {
						border: 1px solid #37beeb;
					}
					.plus-minus-holder {
						height: 40px;
					}
				`}
			</style>
		</div>
	);
};

export default connect(mapStateToProps, { closeModal, updateAdjustment })(
	PartialStairCarryModal
);
